/* ==========================================================================
   US-Parts24 · R516 — Inhaltsverzeichnis für die Rechtstexte.

   Anlass: Die AGB haben seit Teil B 30 Paragraphen auf 24.783 Zeichen. Ohne
   Navigation findet niemand § B 10, und Marcel selbst auch nicht, wenn ein
   Kunde danach fragt.

   Shopify rendert /policies/* mit eigenem Markup — eine Theme-Vorlage dafür
   gibt es nicht. Deshalb hier: Überschriften einsammeln, IDs vergeben,
   Verzeichnis davorhängen. Der Rechtstext selbst wird NICHT angefasst.

   Zugeklappt als Ausgangszustand: ein aufgeklapptes Verzeichnis mit 33
   Einträgen schiebt den Text unter die Falz. `<details>` merkt sich den
   Zustand nicht über Seitenwechsel — das ist hier richtig, sonst wäre die
   Entscheidung des Nutzers auf einer anderen Richtlinie plötzlich falsch.
   ========================================================================== */
(function () {
  "use strict";

  var koerper = document.querySelector(".shopify-policy__body");
  if (!koerper) return;

  var kopfe = koerper.querySelectorAll("h2, h3");
  // Unter sechs Überschriften hilft ein Verzeichnis nicht, es stört nur.
  if (kopfe.length < 6) return;

  var benutzt = Object.create(null);

  function kennung(text, i) {
    var roh = text
      .toLowerCase()
      .replace(/§/g, "par")
      .replace(/[äöüß]/g, function (z) {
        return { "ä": "ae", "ö": "oe", "ü": "ue", "ß": "ss" }[z];
      })
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 48);
    var id = roh || "abschnitt-" + i;
    // Doppelte Überschriften gibt es wirklich: "Widerrufsrecht" steht in
    // Teil 1 und Teil 2 der Widerrufsbelehrung. Ohne Zähler springt der
    // zweite Link auf den ersten Abschnitt.
    if (benutzt[id]) {
      benutzt[id] += 1;
      id += "-" + benutzt[id];
    } else {
      benutzt[id] = 1;
    }
    return id;
  }

  /* Aufbau: Eintraege VOR dem ersten Teil kommen in eine eigene Liste ganz
     oben, danach je Teil eine Gruppe nebeneinander. Bewusst KEINE CSS-Spalten
     mehr: gemessen stand "Teil B" unten in Spalte 1, waehrend § B 1 schon oben
     in Spalte 2 begann. Der Spaltenfluss trennt Kopf und Inhalt, und
     break-after: avoid haelt das im Mehrspaltensatz nicht zuverlaessig. */
  var vorlauf = document.createElement("ul");
  vorlauf.className = "usp-legal-nav__list usp-legal-nav__list--vorlauf";
  var gruppen = document.createElement("div");
  gruppen.className = "usp-legal-nav__gruppen";

  var aktuelleListe = vorlauf;
  var anzahl = 0;

  Array.prototype.forEach.call(kopfe, function (k, i) {
    var text = (k.textContent || "").trim();
    if (!text) return;
    if (i === 0 && k.tagName === "H2") return;   // Dokumentueberschrift

    if (!k.id) k.id = kennung(text, i);

    if (k.tagName === "H2") {
      var gruppe = document.createElement("div");
      gruppe.className = "usp-legal-nav__gruppe";
      var kopfzeile = document.createElement("a");
      kopfzeile.className = "usp-legal-nav__teil";
      kopfzeile.href = "#" + k.id;
      kopfzeile.textContent = text;
      gruppe.appendChild(kopfzeile);
      aktuelleListe = document.createElement("ul");
      aktuelleListe.className = "usp-legal-nav__list";
      gruppe.appendChild(aktuelleListe);
      gruppen.appendChild(gruppe);
      anzahl += 1;
      return;
    }

    // "§ B 10 Nicht abgenommene Sendungen" → Nummer und Titel trennen,
    // damit die Nummern in einer Spalte stehen und das Auge sie greifen kann.
    var teile = text.match(/^(§\s*B?\s*\d+|[0-9]+\.)\s*(.*)$/);
    var nr = teile ? teile[1].replace(/\s+/g, "\u00a0") : "";
    var titel = teile ? teile[2] : text;

    var li = document.createElement("li");
    li.className = "usp-legal-nav__item";
    var a = document.createElement("a");
    a.href = "#" + k.id;
    if (nr) {
      var sp = document.createElement("span");
      sp.className = "usp-legal-nav__nr";
      sp.textContent = nr;
      a.appendChild(sp);
    }
    a.appendChild(document.createTextNode(titel));
    li.appendChild(a);
    aktuelleListe.appendChild(li);
    anzahl += 1;
  });

  if (anzahl < 6) return;

  var box = document.createElement("details");
  box.className = "usp-legal-nav";
  var kopf = document.createElement("summary");
  kopf.textContent = "Inhalt · " + anzahl + " Abschnitte";
  box.appendChild(kopf);
  if (vorlauf.children.length) box.appendChild(vorlauf);
  if (gruppen.children.length) box.appendChild(gruppen);
  koerper.parentNode.insertBefore(box, koerper);

  /* Zurück nach oben.

     ACHTUNG, hier steckte ein Fehler: Die erste Fassung schaltete den Knopf
     über `window.scrollY > window.innerHeight` ein. Auf diesem Theme läuft
     aber Lenis im transform-Modus — die Seite wird verschoben, nicht nativ
     gescrollt. Gemessen bei voll heruntergescrolltem Dokument:

         window.scrollY             0
         document.body.scrollHeight 768   (= Fensterhöhe)
         Inhalt tatsächlich um      12.500 px verschoben

     Der Knopf wäre also NIE erschienen. Deshalb:
       · Sichtbarkeit über IntersectionObserver auf eine Marke ganz oben —
         der misst die Lage im Bild und ist vom Scrollverfahren unabhängig.
       · Der Knopf ist ein echter Anker auf diese Marke, kein Skript-Sprung.
         Die Sprungmarken des Verzeichnisses funktionieren nachweislich; also
         denselben Weg nehmen, statt einen zweiten zu erfinden. Er funktioniert
         damit auch, wenn dieses Skript einmal nicht lädt. */
  var marke = document.createElement("span");
  marke.id = "usp-legal-oben";
  marke.setAttribute("aria-hidden", "true");
  box.parentNode.insertBefore(marke, box);

  var hoch = document.createElement("a");
  hoch.className = "usp-legal-top";
  hoch.href = "#usp-legal-oben";
  hoch.textContent = "Nach oben";
  document.body.appendChild(hoch);

  /* Ein Direktlink wie /policies/terms-of-service#par-b-10-… landet beim ersten
     Laden sonst irgendwo: Die Kennungen vergibt dieses Skript, der Browser hat
     den Hash aber schon abgearbeitet, bevor `defer` uns startet. Gemessen: Der
     Link auf § B 10 landete bei § 4. Also einmal nachholen, sobald die
     Kennungen stehen — und nur dann, wenn das Ziel jetzt wirklich existiert. */
  if (location.hash.length > 1) {
    var nachziel = null;
    try { nachziel = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (e) {}
    if (nachziel) {
      requestAnimationFrame(function () {
        nachziel.scrollIntoView();
        // Das Verzeichnis aufklappen, wenn jemand direkt auf einen Paragraphen
        // kommt — sonst sieht er nicht, wo im Dokument er gelandet ist.
        box.open = true;
      });
    }
  }

  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (eintraege) {
      hoch.classList.toggle("is-an", !eintraege[0].isIntersecting);
    }, { rootMargin: "0px 0px -85% 0px" }).observe(marke);
  } else {
    hoch.classList.add("is-an");
  }
})();
